const DOCUMENT_TYPES = [
    { value: 'CONTRACT', label: 'Contract Document' },
    { value: 'ID', label: 'Identity Document' },
    { value: 'PROOF_ADDRESS', label: 'Proof of Address' },
    { value: 'OTHER', label: 'Other Document' }
];

export default DOCUMENT_TYPES
